import React from 'react';
import styled from 'styled-components';
import useFeatureControl from './services/hooks/useFeatureControl';
import FeatureList from './components/FeatureList';
import RoleList from './components/RoleList';
import FieldSettingsList from './components/FieldSettingsList';

const FeatureControlMain: React.FC = () => {
  const {
    features,
    selectedFeature,
    handleSelectFeature,
    roles,
    selectedRole,
    handleSelectRole,
    fieldSettings,
    handleFieldChange,
    handleSave,
    isLoading,
    hasDirtyFields,
  } = useFeatureControl();

  const isRolesVisible = !!selectedFeature;
  const isFieldsVisible = !!selectedFeature && !!selectedRole;

  return (
    <MainWrapper>
      <FieldSettingsList
        fields={fieldSettings}
        onChange={handleFieldChange}
        onSave={handleSave}
        isLoading={isLoading}
        hasDirtyFields={hasDirtyFields}
        isVisible={isFieldsVisible}
        selectedRole={selectedRole}
      />
      <RoleList
        roles={roles}
        selectedRole={selectedRole}
        onSelect={handleSelectRole}
        isVisible={isRolesVisible}
      />
      <FeatureList
        features={features}
        selectedFeature={selectedFeature}
        onSelect={handleSelectFeature}
      />
    </MainWrapper>
  );
};

export default FeatureControlMain;

const MainWrapper = styled.div`
  --primary-green: #297f76;
  --primary-green-dark: #1e8449;
  --bg-light: #f5f7fa;
  --bg-white: #ffffff;
  --text-primary: #1f1f1f;
  --shadow-light: rgba(0, 0, 0, 0.06);
  --shadow-green: rgba(41, 127, 118, 0.15);

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1em;
  z-index: 1;
  background: #fdfdfd;
  border-radius: 30px;
  padding: 0.75em;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(41, 127, 118, 0.08);
`;
